import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { color } from '../../templates/Ui';
import Loader from './../icons/Loader';
import { ButtonVariants } from './ButtonVariants';
export { ButtonVariants } from './ButtonVariants';
const StyledButton = styled.button `
    position: relative;
    transition: all 0.2s ease-in-out;
    align-self: ${props => (props.alignSelf ? props.alignSelf : 'auto')};
    border: none;
    color: ${color.body.base};
    border-radius: 6px;
    font-weight: 700;
    font-size: 16px;
    padding: ${props => (props.icon ? '16px 55px 16px 20px' : '16px 20px')};
    cursor: pointer;
    width: ${props => (props.fullWidth ? '100%' : 'auto')};
    margin: ${props => props.margin};

    &:hover,
    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: ${props => props.theme.primary.base} auto 1px;
    }

    &:focus-visible {
        outline-color: -webkit-focus-ring-color;
    }

    &:disabled {
        pointer-events: none;
        cursor: default;
        background-color: ${color.gray.darker};
    }

    ${props => props.textPrimary &&
    css `
            color: ${props => props.theme.primary.base};

            &:hover,
            &:focus {
                color: ${props => props.theme.secondary};
            }
        `};

    ${props => props.primary &&
    css `
            background-color: ${props => props.theme.button?.base};
            color: ${props => props.theme.button.color};

            &:hover,
            &:focus {
                background-color: ${props => props.theme.button?.hover};
            }

            &:disabled {
                background-color: ${props => props.theme.button.disabled};
            }

            svg {
                fill: white;
            }
        `};

    ${props => props.secondary &&
    css `
            background-color: ${props => props.theme.secondaryButton?.base};
            color: ${props => props.theme.secondaryButton.color};

            &:hover,
            &:focus {
                background-color: ${props => props.theme.secondaryButton?.hover};
            }

            &:disabled {
                background-color: ${props => props.theme.secondaryButton.disabled};
            }

            svg {
                fill: ${props => props.theme.secondaryButton.color};
            }
        `};

    ${props => props.tertiary &&
    css `
            background-color: ${props => props.theme.tertiaryButton?.base};
            color: ${props => props.theme.tertiaryButton.color};

            &:hover,
            &:focus {
                background-color: ${props => props.theme.tertiaryButton?.hover};
            }

            &:disabled {
                background-color: ${props => props.theme.tertiaryButton.disabled};
            }

            svg {
                fill: ${props => props.theme.tertiaryButton.color};
            }
        `};

    ${props => props.transparent &&
    css `
            background-color: transparent;
            color: ${props => props.theme.primary.base};

            &:hover,
            &:focus {
                background-color: transparent;
            }
        `};

    ${({ variant }) => variant === ButtonVariants.Gray &&
    css `
            background-color: #e3e3e3;
            color: #717171;

            svg {
                fill: #717171;
            }

            &:hover,
            &:focus {
                background-color: #c6c6c6;
            }
        `};

    ${({ variant }) => variant === ButtonVariants.Red &&
    css `
            background-color: ${color.error.base};
            color: white;

            &:hover,
            &:focus {
                background-color: ${color.error.hover};
            }
        `};
`;
const Content = styled.span `
    display: flex;
    align-items: center;
    width: 100%;
    opacity: ${props => (props.isLoading ? '0' : '1')};
    justify-content: ${props => props.textAlign || 'normal'};
`;
const IconWrapper = styled.div `
    display: flex;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 15px;
`;
const StyledLoader = styled(Loader) `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 28px;
    height: 28px;
    stop-color: ${props => props.loaderColor};
    fill: ${props => props.loaderColor};
`;
function Button({ isLoading = false, icon, children, className, fullWidth, primary, alignSelf, secondary, tertiary, textAlign, transparent, margin, textPrimary, variant, loaderColor, ...restProps }) {
    return (_jsx(StyledButton, { icon: icon, disabled: restProps.disabled || isLoading, fullWidth: fullWidth, primary: primary, secondary: secondary, tertiary: tertiary, transparent: transparent, margin: margin, textPrimary: textPrimary, className: className, alignSelf: alignSelf, variant: variant, loaderColor: loaderColor, ...restProps, children: _jsxs(_Fragment, { children: [isLoading && _jsx(StyledLoader, { loaderColor: loaderColor }), _jsxs(Content, { isLoading: isLoading, className: "button__content", textAlign: textAlign, children: [children, icon && (_jsx(IconWrapper, { className: "button__icon-wrapper", children: icon }))] })] }) }));
}
Button.Variant = ButtonVariants;
export default Button;
